import {IComponentOptions, ILogService} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";

class NavigatingAwayModalController {
    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;

    /* @ngInject */
    constructor(private $log: ILogService) {
    }

    public proceed() {
        this.close();
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const NavigatingAwayModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: NavigatingAwayModalController,
    template: require("./navigating-away-modal.html")
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/navigation/navigating-away-modal/navigating-away-modal.component.ts